export default __webpack_public_path__ + "static/media/wave.746676b8.gif";